const captcha = {
    key: '6Lck9ponAAAAAJfxPOe215GZOATInwyccqBwiSqg'
}

export default captcha;